module.exports = __webpack_public_path__ + "static/img/img_monitor_warning_1.555718a7.png";